import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  container: {
    alignItems: 'center',
    display: 'flex',
    position: 'absolute',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    overflow: 'auto'
  },
  title: {
    marginBottom: 15
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20
  }
});
